import { toString as toString_2, Record, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { DomainEntities, DomainEntities_$reflection } from "../DomainEvents.fs.js";
import { FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { record_type, int32_type, bool_type, list_type, string_type, class_type, union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { PromiseBuilder__For_1565554B, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { Route_$007CGuid$007C_$007C, RouterModule_urlSegments } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { signOff as signOff_1, single } from "../Api/Activities.fs.js";
import { single as single_1 } from "../Api/Actions.fs.js";
import { FSharpResult$2, Result_Map } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { single as single_2 } from "../Api/Entities.fs.js";
import { iterate, reverse, ofSeq, collect, append as append_1, length, singleton, cons, empty, ofArray, map, choose, head, tail, isEmpty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { List_groupBy } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";
import { orElse, defaultArg, some, map as map_1 } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { int32ToString, equals, round, createObj, compare, comparePrimitives, uncurry2, defaultOf, stringHash } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import * as jspdf from "jspdf";
import { Csv_encode, EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString, System_String__String_ToOption_Static_Z721C83C5, dataUrlToCanvas, readAsDataUrlPromise } from "../Prelude.fs.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { TaskMsg, useFeliz_UseElmish_React__React_useTaskDispatch_Static } from "../hooks/UseTaskDispatch.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { interpolate, toText, join, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { fromString } from "../hooks/../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { toString } from "../hooks/../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6 } from "../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { detectQROnFiles } from "./PDFQRScanner.fs.js";
import { newGuid } from "../fable_modules/fable-library-js.4.24.0/Guid.js";
import { FSharpMap__TryFind, tryFind, change as change_1, ofList, empty as empty_1 } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { Documents_ChangeReferences, Documents_UpdateDocument, Activities_Signed, Documents_CreateDocument } from "../ServerTypes.fs.js";
import { many, count, changeReferences as changeReferences_1, update as update_1, create as create_5, createUpload } from "../Api/Documents.fs.js";
import { DomainEntity__get_Id, DomainEntity__get_Name } from "../ClientTypes.fs.js";
import { utcNow as utcNow_1, toString as toString_1 } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { FSharpSet__get_Count, toList as toList_1, ofList as ofList_1 } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { Modal_ModalWithFooter, Modal_ModalWithBreakdown } from "./Modal.fs.js";
import { collect as collect_1, map as map_2, empty as empty_2, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.24.0/Range.js";
import { Fa_IconOption, Fa_i } from "../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { defaultOf as defaultOf_1 } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { op_PlusPlus } from "../fable_modules/Feliz.Bulma.3.0.0/Operators.fs.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/./UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Feliz.UseElmish.2.5.0/../Fable.Elmish.4.2.0/program.fs.js";
import { DomainEntitiesSelector } from "../components/EntitySelector.fs.js";
import { StringBuilder__AppendLine_Z721C83C5, StringBuilder_$ctor } from "../fable_modules/fable-library-js.4.24.0/System.Text.js";
import file_saver from "file-saver";

class QRErrors extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UnknownFormat", "InvalidProject", "MissingEntity"];
    }
}

function QRErrors_$reflection() {
    return union_type("EPM.App.Modals.Document.QRErrors", [], QRErrors, () => [[], [], [["Item1", DomainEntities_$reflection()], ["Item2", FetchError_$reflection()]]]);
}

class DocumentFile extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["File", "GeneratedPDF"];
    }
}

function DocumentFile_$reflection() {
    return union_type("EPM.App.Modals.Document.DocumentFile", [], DocumentFile, () => [[["Item", class_type("Browser.Types.File", undefined)]], [["Item1", class_type("Browser.Types.Blob", undefined)], ["Item2", list_type(string_type)]]]);
}

function gatherQRData(currentProjectId, qr) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const parts = RouterModule_urlSegments(qr, 2);
        let matchResult, activityId, projectId;
        if (!isEmpty(parts)) {
            if (!isEmpty(tail(parts))) {
                if (!isEmpty(tail(tail(parts)))) {
                    if (head(tail(tail(parts))) === "projects") {
                        if (!isEmpty(tail(tail(tail(parts))))) {
                            const activePatternResult = Route_$007CGuid$007C_$007C(head(tail(tail(tail(parts)))));
                            if (activePatternResult != null) {
                                if (!isEmpty(tail(tail(tail(tail(parts)))))) {
                                    if (head(tail(tail(tail(tail(parts))))) === "Activity") {
                                        if (!isEmpty(tail(tail(tail(tail(tail(parts))))))) {
                                            const activePatternResult_1 = Route_$007CGuid$007C_$007C(head(tail(tail(tail(tail(tail(parts)))))));
                                            if (activePatternResult_1 != null) {
                                                if (isEmpty(tail(tail(tail(tail(tail(tail(parts)))))))) {
                                                    matchResult = 0;
                                                    activityId = activePatternResult_1;
                                                    projectId = activePatternResult;
                                                }
                                                else {
                                                    matchResult = 1;
                                                }
                                            }
                                            else {
                                                matchResult = 1;
                                            }
                                        }
                                        else {
                                            matchResult = 1;
                                        }
                                    }
                                    else {
                                        matchResult = 1;
                                    }
                                }
                                else {
                                    matchResult = 1;
                                }
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return (currentProjectId === projectId) ? (single(currentProjectId, activityId).then((_arg) => {
                    let matchValue, actionId;
                    const activity = _arg;
                    if (activity.tag === 0) {
                        const activity_1 = activity.fields[0];
                        return ((matchValue = activity_1.ActionId, (matchValue != null) ? ((actionId = matchValue, PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (single_1(currentProjectId, actionId).then((_arg_1) => (Promise.resolve(Result_Map((Value) => Value, _arg_1))))))))) : (Promise.resolve(new FSharpResult$2(0, [undefined]))))).then((_arg_2) => {
                            const actionResult = _arg_2;
                            if (actionResult.tag === 0) {
                                const action_1 = actionResult.fields[0];
                                const matchValue_1 = activity_1.TargetEntity;
                                if (matchValue_1 != null) {
                                    const targetEntity = matchValue_1;
                                    return single_2(targetEntity.EntityType, currentProjectId, targetEntity.EntityId).then((_arg_3) => {
                                        const target = _arg_3;
                                        return (target.tag === 0) ? (Promise.resolve(new FSharpResult$2(0, [[activity_1, action_1, target.fields[0]]]))) : (Promise.resolve(new FSharpResult$2(1, [new QRErrors(2, [targetEntity.EntityType, target.fields[0]])])));
                                    });
                                }
                                else {
                                    return Promise.resolve(new FSharpResult$2(0, [[activity_1, action_1, undefined]]));
                                }
                            }
                            else {
                                return Promise.resolve(new FSharpResult$2(1, [new QRErrors(2, [new DomainEntities(11, []), actionResult.fields[0]])]));
                            }
                        });
                    }
                    else {
                        return Promise.resolve(new FSharpResult$2(1, [new QRErrors(2, [new DomainEntities(5, []), activity.fields[0]])]));
                    }
                })) : (Promise.resolve(new FSharpResult$2(1, [new QRErrors(1, [])])));
            default:
                return Promise.resolve(new FSharpResult$2(1, [new QRErrors(0, [])]));
        }
    }));
}

function processingQRFiles(projectId, files) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr;
        const nonQrFiles = choose((tupledArg) => {
            if (tupledArg[1] == null) {
                return tupledArg[0];
            }
            else {
                return undefined;
            }
        }, files);
        return ((pr = map((tupledArg_2) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (gatherQRData(projectId, tupledArg_2[0]).then((_arg) => (Promise.resolve([map((tuple_1) => tuple_1[0], tupledArg_2[1]), _arg])))))), List_groupBy((tuple) => tuple[1], choose((tupledArg_1) => map_1((qr_2) => [tupledArg_1[0], qr_2], tupledArg_1[1]), files), {
            Equals: (x, y) => (x === y),
            GetHashCode: stringHash,
        })), Promise.all(pr))).then((_arg_1) => (Promise.resolve([nonQrFiles, ofArray(_arg_1)])));
    }));
}

function stichQRFiles(files) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        if (!isEmpty(files)) {
            if (isEmpty(tail(files))) {
                return Promise.resolve(new DocumentFile(0, [head(files)]));
            }
            else {
                const pdf = new jspdf.jsPDF(defaultOf());
                let addPage = false;
                const width = pdf.internal.pageSize.getWidth() - 10;
                const height = pdf.internal.pageSize.getHeight() - 10;
                let fileNames = empty();
                return PromiseBuilder__For_1565554B(promise, files, (_arg) => {
                    const file_1 = _arg;
                    const matchValue = file_1.type;
                    switch (matchValue) {
                        case "image/jpg":
                        case "image/jpeg":
                        case "image/png":
                            return (addPage ? ((void pdf.addPage(), Promise.resolve())) : (Promise.resolve())).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => (readAsDataUrlPromise(file_1).then((_arg_1) => (dataUrlToCanvas(_arg_1).then((_arg_2) => {
                                fileNames = cons(file_1.name, fileNames);
                                pdf.addImage(_arg_2, "PNG", 0, 0, width, height);
                                addPage = true;
                                return Promise.resolve();
                            }))))));
                        default: {
                            return Promise.resolve();
                        }
                    }
                }).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    const blob = pdf.output('blob');
                    return Promise.resolve(new DocumentFile(1, [blob, fileNames]));
                }));
            }
        }
        else {
            return Promise.resolve(new DocumentFile(0, [head(files)]));
        }
    }));
}

export function Create(createInputProps) {
    let xs_60;
    const close = createInputProps.close;
    const projectId = createInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState("");
    const setName = patternInput_1[1];
    const name = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const setDetail = patternInput_2[1];
    const detail = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setIsDrag = patternInput_3[1];
    const patternInput_4 = reactApi.useState("");
    const externalUrl = patternInput_4[0];
    const patternInput_5 = reactApi.useState(true);
    const uploadByFile = patternInput_5[0];
    const patternInput_6 = reactApi.useState(empty());
    const uploadFiles = patternInput_6[0];
    const setUploadFiles = patternInput_6[1];
    const patternInput_7 = reactApi.useState(empty());
    const setNonQRFiles = patternInput_7[1];
    const nonQRFiles = patternInput_7[0];
    const patternInput_8 = reactApi.useState(false);
    const setProcessingQR = patternInput_8[1];
    const processingQR = patternInput_8[0];
    const patternInput_9 = reactApi.useState(empty());
    const setQRFiles = patternInput_9[1];
    const qrFiles = patternInput_9[0];
    let patternInput_11;
    const patternInput_10 = reactApi.useState(() => {
        const existingValue = window.localStorage.getItem("documents.upload.detectQR");
        if (isNullOrWhiteSpace(existingValue)) {
            return false;
        }
        else {
            const result = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(bool_type, undefined, undefined)), existingValue);
            if (result.tag === 1) {
                console.error(some(`Unable to get ${"documents.upload.detectQR"} from local storage`), result.fields[0]);
                return false;
            }
            else {
                return result.fields[0];
            }
        }
    });
    patternInput_11 = [patternInput_10[0], (value_1) => {
        const json = toString(4, Auto_generateBoxedEncoder_437914C6(bool_type, undefined, undefined, undefined)(value_1));
        window.localStorage.setItem("documents.upload.detectQR", json);
        patternInput_10[1](value_1);
    }];
    const detectQR = patternInput_11[0];
    let patternInput_13;
    const patternInput_12 = reactApi.useState(() => {
        const existingValue_1 = window.localStorage.getItem("documents.upload.detectQR.scale");
        if (isNullOrWhiteSpace(existingValue_1)) {
            return 7;
        }
        else {
            const result_1 = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(int32_type, undefined, undefined)), existingValue_1);
            if (result_1.tag === 1) {
                console.error(some(`Unable to get ${"documents.upload.detectQR.scale"} from local storage`), result_1.fields[0]);
                return 7;
            }
            else {
                return result_1.fields[0] | 0;
            }
        }
    });
    patternInput_13 = [patternInput_12[0], (value_1_1) => {
        const json_1 = toString(4, Auto_generateBoxedEncoder_437914C6(int32_type, undefined, undefined, undefined)(value_1_1));
        window.localStorage.setItem("documents.upload.detectQR.scale", json_1);
        patternInput_12[1](value_1_1);
    }];
    const detectQRScale = patternInput_13[0] | 0;
    const dependencies = [uploadFiles, detectQR, detectQRScale];
    reactApi.useEffect(() => {
        setQRFiles(empty());
        setNonQRFiles(empty());
        if (detectQR && !processingQR) {
            setProcessingQR(true);
            let pr_4;
            let pr_3;
            const pr = detectQROnFiles(detectQRScale, uploadFiles);
            pr_3 = (pr.then((files_1) => processingQRFiles(projectId, files_1)));
            pr_4 = (pr_3.then((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let pr_2;
                return ((pr_2 = map((tupledArg_1) => {
                    const pr_1 = stichQRFiles(tupledArg_1[0]);
                    return pr_1.then((pdf) => [pdf, tupledArg_1[1]]);
                }, tupledArg[1]), Promise.all(pr_2))).then((_arg) => {
                    setNonQRFiles(tupledArg[0]);
                    setQRFiles(ofArray(_arg));
                    setProcessingQR(false);
                    return Promise.resolve();
                });
            }))));
            void pr_4;
        }
        else {
            setNonQRFiles(uploadFiles);
        }
        let matchResult, file;
        if (!isEmpty(uploadFiles)) {
            if (isEmpty(tail(uploadFiles))) {
                matchResult = 0;
                file = head(uploadFiles);
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                setName(file.name);
                setDetail(file.name);
                break;
            }
            case 1: {
                break;
            }
        }
    }, dependencies);
    let create_4;
    const dependencies_1_1 = [name, detail, externalUrl, qrFiles, nonQRFiles];
    create_4 = reactApi.useCallback(() => {
        const pr_5 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let matchValue, matchValue_1, name_2, taskId_1, create_1, name_1, url, taskId, create;
            return ((matchValue = System_String__String_ToOption_Static_Z721C83C5(name), (matchValue_1 = System_String__String_ToOption_Static_Z721C83C5(externalUrl), (matchValue != null) ? ((matchValue_1 == null) ? (!isEmpty(nonQRFiles) ? (isEmpty(tail(nonQRFiles)) ? (uploadByFile ? ((name_2 = matchValue, (taskId_1 = newGuid(), (taskDispatch(new TaskMsg(0, [taskId_1, `Create ${head(nonQRFiles).name}`])), (create_1 = (new Documents_CreateDocument(name_2, System_String__String_ToOption_Static_Z721C83C5(detail), empty_1({
                Compare: comparePrimitives,
            }), empty_1({
                Compare: compare,
            }), undefined)), (taskDispatch(new TaskMsg(2, [taskId_1])), createUpload(projectId, create_1, head(nonQRFiles)).then((_arg_2) => {
                const result_3 = _arg_2;
                if (result_3.tag === 1) {
                    taskDispatch(new TaskMsg(6, [taskId_1, result_3.fields[0]]));
                    return Promise.resolve();
                }
                else {
                    taskDispatch(new TaskMsg(3, [taskId_1, undefined]));
                    return Promise.resolve();
                }
            }))))))) : (Promise.resolve())) : (uploadByFile ? PromiseBuilder__For_1565554B(promise, nonQRFiles, (_arg_3) => {
                const file_2 = _arg_3;
                const taskId_2 = newGuid();
                taskDispatch(new TaskMsg(0, [taskId_2, `Create ${file_2.name}`]));
                const create_2 = new Documents_CreateDocument(file_2.name, file_2.name, empty_1({
                    Compare: comparePrimitives,
                }), empty_1({
                    Compare: compare,
                }), undefined);
                taskDispatch(new TaskMsg(2, [taskId_2]));
                return createUpload(projectId, create_2, file_2).then((_arg_4) => {
                    const result_4 = _arg_4;
                    if (result_4.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId_2, result_4.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId_2, undefined]));
                        return Promise.resolve();
                    }
                });
            }) : (Promise.resolve()))) : (uploadByFile ? PromiseBuilder__For_1565554B(promise, nonQRFiles, (_arg_3) => {
                const file_2 = _arg_3;
                const taskId_2 = newGuid();
                taskDispatch(new TaskMsg(0, [taskId_2, `Create ${file_2.name}`]));
                const create_2 = new Documents_CreateDocument(file_2.name, file_2.name, empty_1({
                    Compare: comparePrimitives,
                }), empty_1({
                    Compare: compare,
                }), undefined);
                taskDispatch(new TaskMsg(2, [taskId_2]));
                return createUpload(projectId, create_2, file_2).then((_arg_4) => {
                    const result_4 = _arg_4;
                    if (result_4.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId_2, result_4.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId_2, undefined]));
                        return Promise.resolve();
                    }
                });
            }) : (Promise.resolve()))) : (uploadByFile ? (Promise.resolve()) : ((name_1 = matchValue, (url = matchValue_1, (taskId = newGuid(), (taskDispatch(new TaskMsg(0, [taskId, "Create"])), (create = (new Documents_CreateDocument(name_1, System_String__String_ToOption_Static_Z721C83C5(detail), empty_1({
                Compare: comparePrimitives,
            }), empty_1({
                Compare: compare,
            }), url)), (taskDispatch(new TaskMsg(2, [taskId])), create_5(projectId, create).then((_arg_1) => {
                const result_2 = _arg_1;
                if (result_2.tag === 1) {
                    taskDispatch(new TaskMsg(6, [taskId, result_2.fields[0]]));
                    return Promise.resolve();
                }
                else {
                    taskDispatch(new TaskMsg(3, [taskId, undefined]));
                    return Promise.resolve();
                }
            })))))))))) : ((matchValue_1 == null) ? (uploadByFile ? PromiseBuilder__For_1565554B(promise, nonQRFiles, (_arg_3) => {
                const file_2 = _arg_3;
                const taskId_2 = newGuid();
                taskDispatch(new TaskMsg(0, [taskId_2, `Create ${file_2.name}`]));
                const create_2 = new Documents_CreateDocument(file_2.name, file_2.name, empty_1({
                    Compare: comparePrimitives,
                }), empty_1({
                    Compare: compare,
                }), undefined);
                taskDispatch(new TaskMsg(2, [taskId_2]));
                return createUpload(projectId, create_2, file_2).then((_arg_4) => {
                    const result_4 = _arg_4;
                    if (result_4.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId_2, result_4.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId_2, undefined]));
                        return Promise.resolve();
                    }
                });
            }) : (Promise.resolve())) : (Promise.resolve()))))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => PromiseBuilder__For_1565554B(promise, qrFiles, (_arg_5) => {
                const qr_2 = _arg_5[1];
                const file_3 = _arg_5[0];
                if (qr_2.tag === 1) {
                    return Promise.resolve();
                }
                else {
                    const target = qr_2.fields[0][2];
                    const activity = qr_2.fields[0][0];
                    const actionOpt = qr_2.fields[0][1];
                    const taskId_3 = newGuid();
                    const targetName = (target != null) ? (`-${DomainEntity__get_Name(target)}`) : "";
                    const name_4 = `${(actionOpt != null) ? actionOpt.Name : defaultArg(activity.Name, "")}${targetName}-${toString_1(utcNow(), "yyyy-MM-dd")}`;
                    taskDispatch(new TaskMsg(0, [taskId_3, `Upload ${name_4}`]));
                    const patternInput_14 = (file_3.tag === 1) ? [`EPM Generated PDF: ${join(", ", file_3.fields[1])}`, file_3.fields[0]] : [name_4, file_3.fields[0]];
                    const create_3 = new Documents_CreateDocument(name_4, patternInput_14[0], empty_1({
                        Compare: comparePrimitives,
                    }), ofList(singleton([new DomainEntities(5, []), ofList_1(singleton(activity.Id), {
                        Compare: comparePrimitives,
                    })]), {
                        Compare: compare,
                    }), undefined);
                    taskDispatch(new TaskMsg(2, [taskId_3]));
                    return createUpload(projectId, create_3, patternInput_14[1]).then((_arg_6) => {
                        const result_5 = _arg_6;
                        return ((result_5.tag === 1) ? ((taskDispatch(new TaskMsg(6, [taskId_3, result_5.fields[0]])), Promise.resolve())) : ((taskDispatch(new TaskMsg(3, [taskId_3, undefined])), Promise.resolve()))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                            const signOffTaskId = newGuid();
                            const signOff = new Activities_Signed(utcNow(), undefined);
                            taskDispatch(new TaskMsg(0, [signOffTaskId, `Sign off ${name_4}${targetName}`]));
                            return signOff_1(projectId, activity.Id, signOff).then((_arg_7) => {
                                const signOffResult = _arg_7;
                                if (signOffResult.tag === 1) {
                                    taskDispatch(new TaskMsg(6, [signOffTaskId, signOffResult.fields[0]]));
                                    return Promise.resolve();
                                }
                                else {
                                    taskDispatch(new TaskMsg(3, [signOffTaskId, undefined]));
                                    return Promise.resolve();
                                }
                            });
                        }));
                    });
                }
            })));
        }));
        void pr_5;
    }, dependencies_1_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_60 = toList(delay(() => {
            let elms_1, elms;
            return append((length(uploadFiles) !== 1) ? append(singleton_1((elms_1 = ofArray([createElement("label", {
                className: "label",
                children: "Name",
            }), (elms = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
                setName(ev.target.value);
            }], ["defaultValue", name], ["disabled", ((length(uploadFiles) > 1) ? true : (length(qrFiles) > 0)) ? true : processingQR]])))))), createElement("div", {
                className: "control",
                children: reactApi.Children.toArray(Array.from(elms)),
            }))]), createElement("div", {
                className: "field",
                children: reactApi.Children.toArray(Array.from(elms_1)),
            }))), delay(() => {
                let elms_3, elms_2;
                return singleton_1((elms_3 = ofArray([createElement("label", {
                    className: "label",
                    children: "Detail",
                }), (elms_2 = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev_1) => {
                    setDetail(ev_1.target.value);
                }], ["defaultValue", detail], ["disabled", ((length(uploadFiles) > 1) ? true : (length(qrFiles) > 0)) ? true : processingQR]])))))), createElement("div", {
                    className: "control",
                    children: reactApi.Children.toArray(Array.from(elms_2)),
                }))]), createElement("div", {
                    className: "field",
                    children: reactApi.Children.toArray(Array.from(elms_3)),
                })));
            })) : empty_2(), delay(() => {
                let elms_4, elems_4;
                return append(singleton_1((elms_4 = ofArray([createElement("label", {
                    className: "label",
                    children: uploadByFile ? "Upload File" : "Upload Url",
                }), createElement("div", createObj(Helpers_combineClasses("control", ofArray([["className", join(" ", ["description-toggle", "pretty", "p-switch", "p-fill"])], (elems_4 = [createElement("input", {
                    type: "checkbox",
                    defaultChecked: uploadByFile,
                    onClick: (_arg_8) => {
                        patternInput_5[1](!uploadByFile);
                    },
                    disabled: processingQR,
                }), createElement("div", {
                    className: "state",
                    children: createElement("label", {}),
                })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))))]), createElement("div", {
                    className: "field",
                    children: reactApi.Children.toArray(Array.from(elms_4)),
                }))), delay(() => {
                    let elms_8, elms_14, elms_13;
                    return append(uploadByFile ? append(singleton_1((elms_8 = singleton(createElement("div", createObj(Helpers_combineClasses("file", toList(delay(() => append(singleton_1(["className", "is-boxed"]), delay(() => append(singleton_1(["className", "has-name"]), delay(() => append(patternInput_3[0] ? singleton_1(["className", "is-warning"]) : singleton_1(["className", "is-info"]), delay(() => {
                        let elems_10, elems_9, elms_7;
                        return singleton_1((elems_10 = [createElement("div", createObj(ofArray([["onDragEnter", (_arg_9) => {
                            setIsDrag(true);
                        }], ["onDragLeave", (_arg_10) => {
                            setIsDrag(false);
                        }], ["onDragOver", (e) => {
                            e.preventDefault();
                            setIsDrag(true);
                        }], ["onDrop", (e_1) => {
                            let list_1, objectArg;
                            e_1.preventDefault();
                            setUploadFiles((list_1 = toList(rangeDouble(0, 1, e_1.dataTransfer.files.length - 1)), map((objectArg = e_1.dataTransfer.files, (index) => (objectArg[index])), list_1)));
                            setIsDrag(false);
                        }], (elems_9 = [(elms_7 = toList(delay(() => append(singleton_1(createElement("input", createObj(cons(["type", "file"], Helpers_combineClasses("file-input", ofArray([["type", "file"], ["multiple", true], ["onChange", (ev_2) => {
                            const fileList = ev_2.target.files;
                            if (!(fileList == null)) {
                                setUploadFiles(toList(delay(() => map_2((i) => fileList.item(i), rangeDouble(0, 1, fileList.length - 1)))));
                            }
                        }], ["disabled", processingQR]])))))), delay(() => {
                            let elms_6, elms_5;
                            return append(singleton_1((elms_6 = ofArray([(elms_5 = singleton(Fa_i(singleton(new Fa_IconOption(11, ["fas fa-file-upload"])), [])), createElement("span", {
                                className: "file-icon",
                                children: reactApi.Children.toArray(Array.from(elms_5)),
                            })), createElement("span", {
                                className: "file-label",
                                children: "Choose Documents...",
                            })]), createElement("span", {
                                className: "file-cta",
                                children: reactApi.Children.toArray(Array.from(elms_6)),
                            }))), delay(() => {
                                if (processingQR) {
                                    return singleton_1(createElement("span", {
                                        className: "file-name",
                                        children: "Processing QR...",
                                    }));
                                }
                                else {
                                    const matchValue_3 = uploadFiles;
                                    let matchResult_1, file_5;
                                    if (!isEmpty(matchValue_3)) {
                                        if (isEmpty(tail(matchValue_3))) {
                                            matchResult_1 = 0;
                                            file_5 = head(matchValue_3);
                                        }
                                        else {
                                            matchResult_1 = 1;
                                        }
                                    }
                                    else {
                                        matchResult_1 = 1;
                                    }
                                    switch (matchResult_1) {
                                        case 0:
                                            return singleton_1(createElement("span", {
                                                className: "file-name",
                                                children: file_5.name,
                                            }));
                                        default:
                                            return singleton_1(createElement("span", {
                                                className: "file-name",
                                                children: `${length(uploadFiles)} documents`,
                                            }));
                                    }
                                }
                            }));
                        })))), createElement("label", {
                            className: "file-label",
                            children: reactApi.Children.toArray(Array.from(elms_7)),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))]));
                    })))))))))))), createElement("div", {
                        className: "field",
                        children: reactApi.Children.toArray(Array.from(elms_8)),
                    }))), delay(() => {
                        let elms_10, elms_9, elems_13;
                        return append(singleton_1((elms_10 = ofArray([(elms_9 = toList(delay(() => (detectQR ? append(singleton_1("Detect QR Code"), delay(() => append(singleton_1(createElement("br", {})), delay(() => {
                            let value_114;
                            return singleton_1((value_114 = "(this will attempt to sign off the activity and reference the document against it, files with errors will not be uploaded)", createElement("small", {
                                children: [value_114],
                            })));
                        })))) : singleton_1("Do Not Detect QR")))), createElement("label", {
                            className: "label",
                            children: reactApi.Children.toArray(Array.from(elms_9)),
                        })), createElement("div", createObj(Helpers_combineClasses("control", ofArray([["className", join(" ", ["description-toggle", "pretty", "p-switch", "p-fill"])], (elems_13 = [createElement("input", {
                            type: "checkbox",
                            defaultChecked: detectQR,
                            onClick: (_arg_11) => {
                                patternInput_11[1](!detectQR);
                            },
                            disabled: processingQR,
                        }), createElement("div", {
                            className: "state",
                            children: createElement("label", {}),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_13))])]))))]), createElement("div", {
                            className: "field",
                            children: reactApi.Children.toArray(Array.from(elms_10)),
                        }))), delay(() => {
                            let value_139;
                            return detectQR ? append(singleton_1(createElement("div", createObj(Helpers_combineClasses("notification", ofArray([["className", "is-info"], ["className", "is-light"], (value_139 = "If QR detection isn\'t working for PDF\'s try increasing the scale or using a higher DPI scanner setting (300 minimum)", ["children", value_139])]))))), delay(() => {
                                let elems_18, elems_17, elms_12, elms_11;
                                return singleton_1(createElement("details", createObj(singleton((elems_18 = [createElement("summary", {
                                    children: reactApi.Children.toArray(["Advanced"]),
                                }), createElement("div", createObj(ofArray([["className", "content"], (elems_17 = [(elms_12 = ofArray([createElement("label", {
                                    className: "label",
                                    children: "Scale",
                                }), (elms_11 = singleton(createElement("input", createObj(cons(["type", "number"], Helpers_combineClasses("input", ofArray([["defaultValue", detectQRScale], ["onChange", (ev_3) => {
                                    const value_151 = ev_3.target.valueAsNumber;
                                    if (!(value_151 == null) && !Number.isNaN(value_151)) {
                                        patternInput_13[1](round(value_151));
                                    }
                                }], ["disabled", processingQR], ["min", 1], ["max", 15]])))))), createElement("div", {
                                    className: "control",
                                    children: reactApi.Children.toArray(Array.from(elms_11)),
                                }))]), createElement("div", {
                                    className: "field",
                                    children: reactApi.Children.toArray(Array.from(elms_12)),
                                }))], ["children", reactApi.Children.toArray(Array.from(elems_17))])])))], ["children", reactApi.Children.toArray(Array.from(elems_18))])))));
                            })) : singleton_1(defaultOf_1());
                        }));
                    })) : singleton_1((elms_14 = ofArray([createElement("label", {
                        className: "label",
                        children: "Url",
                    }), (elms_13 = singleton(createElement("input", createObj(cons(["type", "url"], Helpers_combineClasses("input", ofArray([["onChange", (ev_4) => {
                        patternInput_4[1](ev_4.target.value);
                    }], ["defaultValue", externalUrl]])))))), createElement("div", {
                        className: "control",
                        children: reactApi.Children.toArray(Array.from(elms_13)),
                    }))]), createElement("div", {
                        className: "field",
                        children: reactApi.Children.toArray(Array.from(elms_14)),
                    }))), delay(() => {
                        let elems_24, elems_23, children_19, children_17, children_28;
                        return isEmpty(qrFiles) ? singleton_1(defaultOf_1()) : singleton_1(createElement("div", createObj(Helpers_combineClasses("notification", ofArray([["className", "is-info"], (elems_24 = [createElement("h1", {
                            className: "title",
                            children: "QR Files",
                        }), createElement("h2", {
                            className: "subtitle",
                            children: "The following files will be referenced and signed off and named based on the activity",
                        }), createElement("table", createObj(Helpers_combineClasses("table", ofArray([["className", "is-bordered"], ["className", "is-fullwidth"], ["className", "is-striped"], ["className", "is-narrow"], (elems_23 = [(children_19 = singleton((children_17 = ofArray([createElement("th", {
                            children: ["File Name"],
                        }), createElement("th", {
                            children: ["Action"],
                        }), createElement("th", {
                            children: ["Target"],
                        }), createElement("th", {
                            children: ["Error"],
                        }), createElement("th", {
                            children: ["Preview"],
                        })]), createElement("tr", {
                            children: reactApi.Children.toArray(Array.from(children_17)),
                        }))), createElement("thead", {
                            children: reactApi.Children.toArray(Array.from(children_19)),
                        })), (children_28 = toList(delay(() => map((tupledArg_2) => {
                            const file_6 = tupledArg_2[0];
                            const result_6 = tupledArg_2[1];
                            return createElement("tr", createObj(toList(delay(() => append((result_6.tag === 1) ? singleton_1(op_PlusPlus(["className", "has-background-danger-light"], ["className", "has-text-black"])) : (empty_2()), delay(() => {
                                let elems_22;
                                return singleton_1((elems_22 = toList(delay(() => {
                                    let matchValue_6, children_24, children_22;
                                    return append((matchValue_6 = file_6, (matchValue_6.tag === 1) ? singleton_1((children_24 = singleton((children_22 = map((children_21) => createElement("li", {
                                        children: [children_21],
                                    }), matchValue_6.fields[1]), createElement("ul", {
                                        children: reactApi.Children.toArray(Array.from(children_22)),
                                    }))), createElement("td", {
                                        children: reactApi.Children.toArray(Array.from(children_24)),
                                    }))) : singleton_1(createElement("td", {
                                        children: [matchValue_6.fields[0].name],
                                    }))), delay(() => {
                                        let matchValue_7;
                                        return append((matchValue_7 = result_6, (matchValue_7.tag === 1) ? append(singleton_1(createElement("td", {
                                            children: [defaultOf_1()],
                                        })), delay(() => append(singleton_1(createElement("td", {
                                            children: [defaultOf_1()],
                                        })), delay(() => {
                                            const matchValue_8 = matchValue_7.fields[0];
                                            return (matchValue_8.tag === 0) ? singleton_1(createElement("td", {
                                                children: ["Unknown QR Format"],
                                            })) : ((matchValue_8.tag === 2) ? singleton_1(createElement("td", {
                                                children: [`Missing: ${EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString(matchValue_8.fields[0])}`],
                                            })) : singleton_1(createElement("td", {
                                                children: ["Wrong Project"],
                                            })));
                                        })))) : append(singleton_1(createElement("td", {
                                            children: [defaultArg(orElse(map_1((action_1) => action_1.Name, matchValue_7.fields[0][1]), matchValue_7.fields[0][0].Name), "")],
                                        })), delay(() => append(singleton_1(createElement("td", {
                                            children: [defaultArg(map_1(DomainEntity__get_Name, matchValue_7.fields[0][2]), "None")],
                                        })), delay(() => singleton_1(createElement("td", {
                                            children: [defaultOf_1()],
                                        }))))))), delay(() => {
                                            let children_26;
                                            return singleton_1((children_26 = singleton(createElement("a", createObj(toList(delay(() => append(singleton_1(["className", "has-text-link"]), delay(() => {
                                                let matchValue_9;
                                                return append((matchValue_9 = file_6, (matchValue_9.tag === 1) ? singleton_1(["href", URL.createObjectURL(matchValue_9.fields[0])]) : singleton_1(["href", URL.createObjectURL(matchValue_9.fields[0])])), delay(() => append(singleton_1(["target", "_blank"]), delay(() => append(singleton_1(["rel", "noopener noreferrer"]), delay(() => {
                                                    let elems_21;
                                                    return singleton_1((elems_21 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-external-link-alt"])), [])], ["children", reactApi.Children.toArray(Array.from(elems_21))]));
                                                }))))));
                                            }))))))), createElement("td", {
                                                children: reactApi.Children.toArray(Array.from(children_26)),
                                            })));
                                        }));
                                    }));
                                })), ["children", reactApi.Children.toArray(Array.from(elems_22))]));
                            }))))));
                        }, qrFiles))), createElement("tbody", {
                            children: reactApi.Children.toArray(Array.from(children_28)),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_23))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_24))])])))));
                    }));
                }));
            }));
        })), react.createElement(react.Fragment, {}, ...xs_60)),
        submit: create_4,
        submitText: "Create",
        tasks: patternInput[0],
        title: "Create",
    });
}

export function Update(updateInputProps) {
    let xs_10, elms_1, elms, elms_3, elms_2;
    const close = updateInputProps.close;
    const document$ = updateInputProps.document;
    const projectId = updateInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(document$.Name);
    const name = patternInput_1[0];
    let patternInput_2;
    const initial_1 = defaultArg(document$.Detail, "");
    patternInput_2 = reactApi.useState(initial_1);
    const detail = patternInput_2[0];
    let updates;
    const dependencies_1 = [name, detail];
    updates = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (isNullOrWhiteSpace(name)) {
                return Promise.resolve();
            }
            else {
                const taskId = newGuid();
                taskDispatch(new TaskMsg(0, [taskId, `Update ${name}`]));
                const update = new Documents_UpdateDocument(name, detail);
                taskDispatch(new TaskMsg(2, [taskId]));
                return update_1(projectId, document$.Id, update).then((_arg) => {
                    const result = _arg;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId, undefined]));
                        return Promise.resolve();
                    }
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_10 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Name",
        }), (elms = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["defaultValue", name]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_3 = ofArray([createElement("label", {
            className: "label",
            children: "Detail",
        }), (elms_2 = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev_1) => {
            patternInput_2[1](ev_1.target.value);
        }], ["defaultValue", detail]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_3)),
        }))], react.createElement(react.Fragment, {}, ...xs_10)),
        submit: updates,
        submitText: "Update",
        tasks: patternInput[0],
        title: "Update",
    });
}

class ReferencesState extends Record {
    constructor(References) {
        super();
        this.References = References;
    }
}

function ReferencesState_$reflection() {
    return record_type("EPM.App.Modals.Document.ReferencesState", [], ReferencesState, () => [["References", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [DomainEntities_$reflection(), class_type("Microsoft.FSharp.Collections.FSharpSet`1", [class_type("System.Guid")])])]]);
}

class ReferenceMsg extends Union {
    constructor(Item1, Item2) {
        super();
        this.tag = 0;
        this.fields = [Item1, Item2];
    }
    cases() {
        return ["ChangeReferences"];
    }
}

function ReferenceMsg_$reflection() {
    return union_type("EPM.App.Modals.Document.ReferenceMsg", [], ReferenceMsg, () => [[["Item1", DomainEntities_$reflection()], ["Item2", list_type(class_type("System.Guid"))]]]);
}

function initReferences(existingReferences) {
    return [new ReferencesState(existingReferences), Cmd_none()];
}

function updateReferences(msg, state) {
    const entities = msg.fields[1];
    return [new ReferencesState(change_1(msg.fields[0], (_arg) => {
        if (isEmpty(entities)) {
            return undefined;
        }
        else {
            return ofList_1(entities, {
                Compare: comparePrimitives,
            });
        }
    }, state.References)), Cmd_none()];
}

const tabs = ofArray([new DomainEntities(13, []), new DomainEntities(1, []), new DomainEntities(2, []), new DomainEntities(3, []), new DomainEntities(6, []), new DomainEntities(7, []), new DomainEntities(8, []), new DomainEntities(0, []), new DomainEntities(9, []), new DomainEntities(11, []), new DomainEntities(5, [])]);

export function ChangeReferences(changeReferencesInputProps) {
    let xs_5, elms, children, elms_1;
    const close = changeReferencesInputProps.close;
    const document$ = changeReferencesInputProps.document;
    const projectId = changeReferencesInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(new DomainEntities(13, []));
    const currentTab = patternInput_1[0];
    let patternInput_2;
    const init = initReferences(document$.References);
    patternInput_2 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, updateReferences, (_arg, _arg_1) => {
    }), undefined, []);
    const state_1 = patternInput_2[0];
    let initialEntities;
    const dependencies_1_1 = [currentTab];
    initialEntities = reactApi.useMemo(() => defaultArg(map_1(toList_1, tryFind(currentTab, state_1.References)), empty()), dependencies_1_1);
    let setEntities;
    const dependencies_1_2 = [currentTab];
    setEntities = reactApi.useCallback((entities) => {
        patternInput_2[1](new ReferenceMsg(currentTab, map(DomainEntity__get_Id, entities)));
    }, dependencies_1_2);
    let change;
    const dependencies_1_3 = [state_1.References];
    change = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const taskId = newGuid();
            taskDispatch(new TaskMsg(0, [taskId, `Change References ${document$.Name}`]));
            const changeReferences = new Documents_ChangeReferences(state_1.References);
            taskDispatch(new TaskMsg(2, [taskId]));
            return changeReferences_1(projectId, document$.Id, changeReferences).then((_arg_2) => {
                const result = _arg_2;
                if (result.tag === 1) {
                    taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                    return Promise.resolve();
                }
                else {
                    taskDispatch(new TaskMsg(3, [taskId, undefined]));
                    return Promise.resolve();
                }
            });
        }));
        void pr;
    }, dependencies_1_3);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_5 = [(elms = singleton((children = toList(delay(() => map((tab) => createElement("li", createObj(Helpers_combineClasses("", toList(delay(() => append(equals(tab, currentTab) ? singleton_1(["className", "is-active"]) : empty_2(), delay(() => singleton_1(["children", createElement("a", {
            children: `${EPM_Domain_Events_DomainEntities__DomainEntities_ToProperString(tab)} (${defaultArg(map_1(FSharpSet__get_Count, FSharpMap__TryFind(state_1.References, tab)), 0)})`,
            onClick: (e_1) => {
                e_1.preventDefault();
                patternInput_1[1](tab);
            },
        })])))))))), tabs))), createElement("ul", {
            children: reactApi.Children.toArray(Array.from(children)),
        }))), createElement("div", {
            className: "tabs",
            children: reactApi.Children.toArray(Array.from(elms)),
        })), (elms_1 = singleton(createElement(DomainEntitiesSelector, {
            projectId: projectId,
            entityType: currentTab,
            initialEntities: initialEntities,
            onSelectedEntitiesChange: setEntities,
            filters: empty(),
            isSmall: false,
        })), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        }))], react.createElement(react.Fragment, {}, ...xs_5)),
        submit: change,
        submitText: "Change",
        tasks: patternInput[0],
        title: "Change References",
    });
}

const exportReferencesHeaders = ofArray([{
    key: "documentId",
    name: "DocumentId",
}, {
    key: "documentName",
    name: "DocumentName",
}, {
    key: "documentDetail",
    name: "DocumentDetail",
}, {
    key: "entityId",
    name: "EntityId",
}, {
    key: "entityType",
    name: "EntityType",
}]);

function exportReferences(document$, entityType, entityId) {
    let list_2;
    return ofList((list_2 = choose((x) => x, singleton(map_1((e) => ["documentDetail", e], document$.Detail))), append_1(ofArray([["documentId", document$.Id], ["documentName", document$.Name], ["entityId", entityId], ["entityType", toString_2(entityType)]]), list_2)), {
        Compare: comparePrimitives,
    });
}

function downloadReferencesCSV(setProcessing, setTotal, setFetched, projectId, filters) {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        setProcessing(true);
        return count(projectId, filters).then((_arg) => {
            let initialCount, chunks;
            const initialCountResult = _arg;
            let results = empty();
            let fetchedCount = 0;
            return ((initialCountResult.tag === 0) ? ((initialCount = (initialCountResult.fields[0] | 0), (setTotal(initialCount), (chunks = ((~~(initialCount / 100) + (((initialCount % 100) > 0) ? 1 : 0)) | 0), PromiseBuilder__For_1565554B(promise, rangeDouble(0, 1, chunks - 1), (_arg_1) => {
                const apiParams = ofArray([["fetch", int32ToString(100)], ["offset", int32ToString(_arg_1 * 100)]]);
                return many(projectId, apiParams, filters).then((_arg_2) => {
                    const dataResult = _arg_2;
                    if (dataResult.tag === 0) {
                        const documents = dataResult.fields[0];
                        const processedData = map((tupledArg) => exportReferences(tupledArg[0], tupledArg[1], tupledArg[2]), collect((document$) => ofSeq(collect_1((reference) => ofSeq(map_2((v) => [document$, reference[0], v], reference[1])), document$.References)), documents));
                        results = append_1(processedData, results);
                        fetchedCount = ((fetchedCount + length(documents)) | 0);
                        setFetched(fetchedCount);
                        return Promise.resolve();
                    }
                    else {
                        console.error(some(dataResult.fields[0]));
                        return Promise.resolve();
                    }
                });
            }).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                const processedData_1 = reverse(results);
                const headers = ofSeq(exportReferencesHeaders);
                const csv = StringBuilder_$ctor();
                StringBuilder__AppendLine_Z721C83C5(csv, join(",", map((header) => Csv_encode(header.name), headers)));
                iterate((row) => {
                    StringBuilder__AppendLine_Z721C83C5(csv, row);
                }, map((data) => join(",", map((header_1) => defaultArg(map_1(Csv_encode, FSharpMap__TryFind(data, header_1.key)), ""), headers)), processedData_1));
                const content = toString_2(csv);
                const now = toString_1(utcNow_1(), "yyyy-MM-dd hh:mm:ss");
                file_saver(new Blob([content], { 'type': "text/csv" }), `document-references-export-${now}.csv`);
                return Promise.resolve();
            })))))) : ((console.error(some(initialCountResult.fields[0])), Promise.resolve()))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                setProcessing(false);
                return Promise.resolve();
            }));
        });
    }));
    void pr;
}

export function ExportReferences(exportReferencesInputProps) {
    const close = exportReferencesInputProps.close;
    const filters = exportReferencesInputProps.filters;
    const projectId = exportReferencesInputProps.projectId;
    const patternInput = reactApi.useState(0);
    const total = patternInput[0] | 0;
    const patternInput_1 = reactApi.useState(0);
    const fetched = patternInput_1[0] | 0;
    const patternInput_2 = reactApi.useState(false);
    const processing = patternInput_2[0];
    return createElement(Modal_ModalWithFooter, {
        close: close,
        content: createElement("progress", createObj(Helpers_combineClasses("progress", ofArray([["className", "is-primary"], ["max", total], ["value", fetched], ["title", toText(interpolate("%.2f%P()%%", [(total === 0) ? 0 : ((fetched / total) * 100)]))]])))),
        disabled: processing,
        footer: singleton(createElement("button", createObj(Helpers_combineClasses("button", toList(delay(() => append(processing ? singleton_1(["className", "is-loading"]) : empty_2(), delay(() => append(singleton_1(["disabled", processing]), delay(() => append(singleton_1(["children", "Download"]), delay(() => singleton_1(["onClick", (_arg) => {
            downloadReferencesCSV(patternInput_2[1], patternInput[1], patternInput_1[1], projectId, filters);
        }]))))))))))))),
        title: "Export References as CSV",
    });
}

